import _get from "lodash/get";
import styled from 'styled-components';
import headerTheme from '../../styles/headerTheme';
var Label = styled.span.withConfig({
  displayName: "Label",
  componentId: "sc-7fjnfc-0"
})(["font-weight:", ";text-transform:", ";"], function (_ref) {
  var theme = _ref.theme;
  return _get(theme, 'header.navigation.label.fontWeight', headerTheme.header.navigation.label.fontWeight);
}, function (_ref2) {
  var theme = _ref2.theme;
  return _get(theme, 'header.navigation.label.uppercase', headerTheme.header.navigation.label.uppercase) ? 'uppercase' : 'none';
});
export default Label;